export const PORTAIL_TICKET_TITLE_PLACEHOLDER =
  "Ex : Le robot se perd après extension du mapping";

export type TicketFieldErrors = {
  titre?: string;
  problemDescription?: string;
};

export function normalizeTicketTitle(value: string): string {
  return value.trim().replace(/\s+/g, " ");
}

export function validateTicketFields(
  titre: string,
  problemDescription: string,
): TicketFieldErrors {
  const errors: TicketFieldErrors = {};
  const normalizedTitle = normalizeTicketTitle(titre);
  const trimmedDescription = problemDescription.trim();

  if (!normalizedTitle) {
    errors.titre = "L'objet est obligatoire.";
  } else if (normalizedTitle.length < 10) {
    errors.titre = "L'objet doit contenir au moins 10 caractères.";
  } else if (normalizedTitle.length > 100) {
    errors.titre = "L'objet doit contenir au maximum 100 caractères.";
  }

  if (!trimmedDescription) {
    errors.problemDescription = "La description du problème est obligatoire.";
  } else if (trimmedDescription.length < 20) {
    errors.problemDescription =
      "La description du problème doit contenir au moins 20 caractères.";
  }

  return errors;
}